/*
* ぽちボタンクリック後の処理
*/ 

import { formatAdditionalOptions } from "./itzai.class"

class afrPostJOBY {
  constructor(that) {
    this.that = that
    this.formName = "JOBY"
    const $ = this.that.$
    const store = this.that.store

    if (store.state.industryNamesData.length == 0) {
      this.that.vueObj.viewLoader('業界リスト読み込み中')
    }

    let i = 0
    const sit = setInterval(() => {
      if (store.state.industryNamesData.length > 0) {
        clearInterval(sit)
        this.that.vueObj.viewLoader()

        if ($('#industry_names_JOBY')[0]) {
          // 再選択時の重複追加を防止
          if ($('#industry_names_JOBY option').length <= 1) {
            const industry_records = store.state.industryNamesData

            for (let j = 0; j < industry_records.length; j++) {
              const record = industry_records[j]
              const option = $('<option>')

              option.attr({
                id: 'jobsCategoriesID_JOBY' + record.id,
                value: record.name,
                'data-id': record.id
              }).text(record.name)

              $('#industry_names_JOBY').append(option).show()
            }
          }
        }
      } else {
        i++
        if (i >= 200) {
          clearInterval(sit)
          alert('業界リストを取得できませんでした\nリロードします')
          window.location.reload()
        }
      }
    }, 50)

    this.that.$('.search_form_wrap').show()
    this.actionInit()
  }

  returnFormName() {
    return this.formName
  }

  getInputData() {
    const $ = this.that.$
    const moment = this.that.moment
    moment.locale("ja")
    const store = this.that.store
    const func = this.that.func

    const jobyCampaignValue = Array.from(
      document.querySelectorAll('input[name="JOBY_campaign"]:checked')
    ).map(input => input.value)

    const jobyPlanValue = Array.from(
      document.querySelectorAll('input[name="JOBY_plan"]:checked')
    ).map(input => input.value)

    const motiveSigningContractValue = Array.from(
      document.querySelectorAll('input[name="motive_signing_contract_JOBY"]:checked')
    ).map(input => input.value)

    const persnalityValue = Array.from(
      document.querySelectorAll('input[name="persnality_JOBY"]:checked')
    ).map(input => input.value)

    //制作前共有
    store.commit('setValue', ['JOBY', 'input_JOBY_campaign', jobyCampaignValue, 'JOBY_campaign'])
    store.commit('setValue', ['JOBY', 'input_JOBY_plan', jobyPlanValue, 'JOBY_plan'])
    store.commit('setValue', ['JOBY', 'input_JOBY_production_count', func.textEscape($('#production_count_JOBY').val()), ''])
    store.commit('setValue', ['JOBY', 'input_JOBY_industry', $('#industry_names_JOBY').val() || '', ''])
    store.commit('setValue', ['JOBY', 'input_JOBY_job_title', func.textEscape($('#job_title_JOBY').val()), ''])
    store.commit('setValue', ['JOBY', 'input_JOBY_additional_options', formatAdditionalOptions('additional_options_joby'), ''])
    store.commit('setValue', ['JOBY', 'input_JOBY_motive_signing_contract', motiveSigningContractValue, ''])
    store.commit('setValue', ['JOBY', 'input_JOBY_persnality', persnalityValue, ''])
    store.commit('setValue', ['JOBY', 'input_JOBY_conv', func.textEscape($('#conv_JOBY').val()), ''])
    store.commit('setValue', ['JOBY', 'input_JOBY_shootDate', $("#shootDate_JOBY").val(), 'shootDate_JOBY'])
    store.commit('setValue', ['JOBY', 'input_JOBY_rctBackground', func.textEscape($('#rctBackground_JOBY').val()), ''])
    store.commit('setValue', ['JOBY', 'input_JOBY_kind_person_Hope', func.textEscape($('#kind_person_Hope_JOBY').val()), ''])
    store.commit('setValue', ['JOBY', 'input_JOBY_otherHope', func.textEscape($('#otherHope_JOBY').val()), ''])
    store.commit('setValue', ['JOBY', 'input_JOBY_contractReason', func.textEscape($('#contractReason_JOBY').val()), ''])
    store.commit('setValue', ['JOBY', 'input_JOBY_remarks', func.textEscape($('#remarks_JOBY').val()), ''])
    store.commit('setValue', ['JOBY', 'inputBoostCampaign', $('[name="boost_campaign_joby"]:checked').val(), ''])
    store.commit('setValue', ['JOBY', 'inputJOBYContractFee', $('#JOBYContractFee').val(), ''])
    store.commit('setValue', ['JOBY', 'inputJOBYAdvertisingFee', $('#JOBYAdvertisingFee').val(), ''])
    store.commit('setValue', ['JOBY', 'inputJOBYSystemFee', $('#JOBYSystemFee').val(), ''])

  }

  setVal (balanceInfoMsg) {
    const store = this.that.store

    let sendValFront = 
`
◎JOBY
`

    let sendVal = 
`プラン：${store.state.formData.JOBY.input_JOBY_plan}
募集要項制作代行数：${store.state.formData.JOBY.input_JOBY_production_count}
業界：${store.state.formData.JOBY.input_JOBY_industry}
募集職種名：${store.state.formData.JOBY.input_JOBY_job_title}
追加オプション：${store.state.formData.JOBY.input_JOBY_additional_options}
契約動機：${store.state.formData.JOBY.input_JOBY_motive_signing_contract}
契約動機詳細：${store.state.formData.JOBY.input_JOBY_contractReason}
顧客人柄：${store.state.formData.JOBY.input_JOBY_persnality}
お客様との会話内容（世間話を含めて）：${store.state.formData.JOBY.input_JOBY_conv}
掲載希望日時（ヒアアポ～の期間・撮影期間を伝えた上で）：${store.state.formData.JOBY.input_JOBY_shootDate}
求人背景（他媒体効果など）：${store.state.formData.JOBY.input_JOBY_rctBackground}
どういう人が取りたいか：${store.state.formData.JOBY.input_JOBY_kind_person_Hope}
その他顧客希望：${store.state.formData.JOBY.input_JOBY_otherHope}
備考：${store.state.formData.JOBY.input_JOBY_remarks}
広告費100万ブーストキャンペーンを適用しましたか？：${store.state.formData.JOBY.inputBoostCampaign}
JOBY契約総額：${store.state.formData.JOBY.inputJOBYContractFee}円
広告費：${store.state.formData.JOBY.inputJOBYAdvertisingFee}円
システム費：${store.state.formData.JOBY.inputJOBYSystemFee}円
`

    sendVal = store.state.formData.JOBY.input_JOBY_campaign == "有り" ? sendValFront + "期間：【6ヶ月】\n" + sendVal : sendValFront + sendVal

    store.commit('setTalknoteMessage', ['JOBY', sendVal])
  }

  actionInit() {
    const $ = this.that.$

  }
}

export default {
  afrPostJOBY
}
